import { HistoryItem, ResourceType } from "@common/types/auditLog";
import { HistoryRow } from "../views/historyViewConfig";
import { resolveHistoryEntityIds } from "./resolveHistoryEntityIds";

/**
 * The Activity page's row id for a grouped history item, so a row keeps its
 * identity across refetches and every surface listing the same items agrees.
 */
export const getHistoryRowId = (item: HistoryItem): string =>
    [
        item.date,
        item.sourceType,
        item.actorId ?? item.organizationActorId ?? "system",
        item.fields.join("-") || "unknown",
        item.resourceIds.join("-"),
        item.channel ?? "none",
    ].join("-");

// Shared HistoryItem -> HistoryRow mapping so every surface (the main History
// page and the CoA template Activity drawer) resolves entity ids the same way.
// Callers supply the row `id` because it differs per surface, and may layer on
// surface-specific fields (e.g. `member`) via spread.
export function historyItemToRow({
    item,
    id,
}: {
    item: HistoryItem;
    id: string;
}): HistoryRow {
    return {
        id,
        date: item.date,
        actorId: item.actorId,
        actorName: item.actorName,
        actorType: item.actorType ?? "SYSTEM",
        sourceType: item.sourceType,
        resourceType: item.resourceType,
        changeTypes: item.changeTypes,
        fields: item.fields,
        count: item.count,
        resourceIds: item.resourceIds,
        resources: item.resources,
        entityIds: resolveHistoryEntityIds({
            entityIds: item.entityIds,
            resources:
                item.resourceType === ResourceType.FINANCIAL_DOCUMENT
                    ? undefined
                    : item.resources,
        }),
        historyItem: item,
        revertedAt: item.revertedAt ?? undefined,
        system: item.system ?? null,
        channel: item.channel ?? null,
    };
}
